import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';

type GetMe = {
	extended_profile: ExtendedProfile;
};
type ExtendedProfile = {
	job_title: string;
	team_type: string;
};
export type GetUserSegmentationDataResponse = {
	teamType?: string;
	title?: string;
};

const LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY = 'loom-recorder.user-segmentation';

const handleFetchResponse = (response: Response) => {
	if (response.ok) {
		return response.json();
	}

	const error = new Error(`API responded with failure HTTP code: ${response.status}`);
	throw error;
};

export const getAtlassianAccount = async (): Promise<GetMe> =>
	fetch('https://cc-fe-bifrost.prod-east.frontend.public.atl-paas.net/gateway/api/me').then(handleFetchResponse);

export const getUserSegmentationData = async (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
): Promise<GetUserSegmentationDataResponse> => {
	// Try to read from local storage
	try {
		const cachedUserSegmentation = localStorage.getItem(
			LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY,
		);
		if (cachedUserSegmentation) {
			createAnalyticsEvent({
				action: 'succeeded',
				actionSubject: 'growth.loomUtils.getUserSegmentationData',
				attributes: { fromLocalStorage: true },
				eventType: 'operational',
			}).fire('growth');
			return JSON.parse(cachedUserSegmentation) as GetUserSegmentationDataResponse;
		}
	} catch (e) {
		// Ignore localStorage errors
	}

	try {
		const { extended_profile: extendedProfile } = await getAtlassianAccount();

		const userSegmentationData = {
			title: extendedProfile?.job_title,
			teamType: extendedProfile?.team_type,
		};

		createAnalyticsEvent({
			action: 'succeeded',
			actionSubject: 'growth.loomUtils.getUserSegmentationData',
			attributes: { fromLocalStorage: false },
			eventType: 'operational',
		}).fire('growth');
		// Save to local storage
		try {
			localStorage.setItem(
				LOOM_UTILS_USER_SEGMENTATION_LOCAL_STORAGE_KEY,
				JSON.stringify(userSegmentationData),
			);
		} catch (e) {
			// Ignore localStorage errors
		}

		return userSegmentationData;
	} catch (error) {
		// Track failure
		createAnalyticsEvent({
			action: 'failed',
			actionSubject: 'growth.loomUtils.getUserSegmentationData',
			attributes: {
				error: error instanceof Error ? error.message : String(error),
			},
			eventType: 'operational',
		}).fire('growth');
	}

	return {};
};
